import React from 'react'
import {Toptips, Toast, Dialog} from 'react-weui'
import axios from 'axios'
import qs from 'qs'
import {WKVisible} from '../../components/wk'
import {StepTab, LectureMode, LectureBasic, LectureAuthority} from '../../components/lectureCreate'

import {isLZWKAPP} from '../../utils'
import { addSuccess } from '../../utils/connectApp'

import '../../css/page/LectureCreateNewPage.css'


class LectureCreateNewPage extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            step: 1, // 1:选择授课方式；2：设置基本信息；3：设置课程权限
            isShow: false,
            isPending: false,
            tip: {
                isShow: false,
                text: '',
                type: 'warn',
            },
            alertDialog: {
                isShow: false,
                text: '',
            },
            category: ''
        }
        this.showTip = this.showTip.bind(this)
        this.handleSetStep = this.handleSetStep.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
    }
    componentDidMount() {
        document.title = '创建课程'
        window.scrollTo(0,0)
        // 如果在专栏内创建课程，判断是否是付费专栏
        if (this.props.location.query.channel_id) {
            axios.get(`/api/channel/${this.props.location.query.channel_id}/short_info`)
                .then(res => {
                    this.refs.lectureAuthority.setField('isChannelNeedMoney', res.data.data.channel.need_money)
                    this.refs.lectureAuthority.setField('selectedRadio', res.data.data.channel.need_money ? 'payChannel' : 'free')
                })
        }
        axios.get(`/api/liveroom/${this.props.params.liveroom_id}/is_first_create`)
            .then(res => {
                if(res.data.data.is_first) {
                    this.refs.lectureBasic.setField('title', `${res.data.data.liveroom_name}的第一节课`)
                }
            })
    }
    handleSetStep(step) {
        let modeData = this.refs.lectureMode.getData()
        let basicVerify = this.refs.lectureBasic.verify()
        if (step === 2) {
            if (!modeData.type) {
                return null
            }
        }
        if (step === 3) {
            if (!basicVerify.status) {
                return null
            }
        }
        this.setState({step})
    }
    showTip(text, type = 'warn') {
        this.setState({
            tip: {isShow: true, text, type},
        })
        setTimeout(() => {
            this.setState({
                tip: {isShow: false},
            })
        }, 2000)
    }
    showAlert (text) {
        this.setState({
            alertDialog: { isShow: true, text }
        })
    }
    handleSubmit() {
        let basicData = this.refs.lectureBasic.getData()
        let authorityData = this.refs.lectureAuthority.getData()
        let {selectedRadio, money, isResell, resellPercent, password, title, startTime, mode} = {...basicData, ...authorityData}

        let payData = {}
        // 专栏里添加课程
        let channelData = {}
        if (selectedRadio === 'free') {
            payData = {
                need_money: false,
            }
        }
        if (selectedRadio === 'unfree') {
            if (isResell) {
                payData = {
                    need_money: true,
                    money: (money * 100).toFixed(),
                    resell_enabled: isResell,
                    resell_percent: resellPercent,
                }
            } else {
                payData = {
                    need_money: true,
                    money: (money * 100).toFixed(),
                }
            }
        }
        if (selectedRadio === 'password') {
            payData = {
                need_password: true,
                password: password
            }
        }
        if (selectedRadio === 'payChannel') {
            payData = {
                need_pay_channel: true,
            }
        }
        if (this.props.location.query.channel_id) {
            channelData = {
                channel: this.props.location.query.channel_id
            }
        }
        const submitData = {
            ...payData,
            ...channelData,
            name: title,
            category: this.state.category,
            start_time: startTime,
            image_mode: mode,
        }
        this.setState({isPending: true})
        axios.post(`/api/liveroom/${this.props.params.liveroom_id}/add_lecture`, qs.stringify(submitData))
            .then(res => {
                this.setState({isPending: false})
                if (res.data.code !== 0) {
                    return this.showTip(res.data.msg)
                }
                this.showAlert('创建成功')
                this.setState({lectureId: res.data.data.lecture_id})
            })
    }
    onClickSuccessOk () {
        if (isLZWKAPP()) {
            this.setState({ alertDialog: { isShow: false } })
            addSuccess('lecture', this.state.lectureId)
        } else {
            location.replace(`/lecture/${this.state.lectureId}?fr=create_lecture`)
        }
    }
    render() {
        const {step} = this.state
        const channelId = this.props.location.query.channel_id

        return (
            <div className="lecture-create-new-page wk-page">
                <StepTab step={step} clickHandle={this.handleSetStep}/>
                <Toast icon="loading" show={this.state.isPending}/>
                <Toptips type={this.state.tip.type} show={this.state.tip.isShow}>{this.state.tip.text}</Toptips>
                <Dialog type="ios" title='' buttons={[
                    { label: '确定', onClick: () => this.onClickSuccessOk() }
                ]} show={this.state.alertDialog.isShow}>
                    {this.state.alertDialog.text}
                </Dialog>
                <div className="lecture-create-body">
                    <WKVisible show={step === 1}>
                        <LectureMode channelId={channelId} clickHandle={this.handleSetStep} ref="lectureMode"/>
                    </WKVisible>
                    <WKVisible show={step === 2}>
                        <LectureBasic clickHandle={{setStep: this.handleSetStep, showTips: this.showTip}} ref="lectureBasic"/>
                    </WKVisible>
                    <WKVisible show={step === 3}>
                        <LectureAuthority clickHandle={{showTips: this.showTip, submit: this.handleSubmit}} ref="lectureAuthority"/>
                    </WKVisible>
                </div>
            </div>
        )
    }
}

export default LectureCreateNewPage


// WEBPACK FOOTER //
// ./src/pages/lectureCreate/LectureCreateNewPage.js